//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../AME/AME.AMEExtendedObject.js";
let d=[[],[[["rhs"],"Disconnect",{},1,0],[["keepUnmanaged"],"Disconnect1",{},1,0],[["exp"],"ConnectViaExpression",{},1,0],[["numPorts"],"GetConnections",{R_:{ports:"AME.IPort[]"}},0,0],[[],"GetPortName",{R_:{portName:''}},0,0],[[],"IsConnected",{R_:{isConnected:''}},0,0],[[],"GetOwningParent",{R_:{obj:"AME.IPortsContainer"}},0,0],[[],"GetPortType",{R_:{portType:''}},0,0],[[],"GetPortDirection",{R_:{portDirection:''}},0,0],[[],"GetPortCardinality",{R_:{portCardinality:''}},0,0]],[]];
SPLM.AME.AssignmentPort = class extends SPLM.AME.AMEExtendedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.AssignmentPort";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;